import { render } from "./FileInput.vue?vue&type=template&id=2b2b7d1d&scoped=true"
import script from "./FileInput.vue?vue&type=script&lang=js"
export * from "./FileInput.vue?vue&type=script&lang=js"

import "./FileInput.vue?vue&type=style&index=0&id=2b2b7d1d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2b7d1d"]])

export default __exports__